exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_container__1vPog{width:100%;display:flex;flex-direction:row}.style_container__1vPog>.style_wide__3iHkR{flex-grow:1}.style_container__1vPog>.style_buttons__3RezA{padding-top:1rem}.style_container__1vPog>:nth-child(2){margin-left:1rem}", ""]);

// exports
exports.locals = {
	"container": "style_container__1vPog",
	"wide": "style_wide__3iHkR",
	"buttons": "style_buttons__3RezA"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/form/VariableLookup/style.less
// module id = 1553
// module chunks = 8